import React, { useState } from "react";
import {
    FormControl,
    FormHelperText,
    Input
} from "@chakra-ui/react";
import { FormControlEvo } from "../FormControlEvo";
import { FormLabelEvo } from "../label/FormLabelEvo";


import {fieldNameAndLabels} from "../../../../infrastructure/utils/formUtils";


export const AntiSpamYearInputEvo = (props: any) => {
    const [year, setYear] = useState('');
    const [isTouched, setIsTouched] = useState(false);

    // Get the current year dynamically
    const currentYear = new Date().getFullYear().toString();

    // Handle form input changes
    const handleChangeYear = (e: React.ChangeEvent<HTMLInputElement>) => {
        setYear(e.target.value);
        props.handleChange(e);
    };

    const handleKeyPress = () => {
        setIsTouched(true);
    };

    const isValidYear = (inputYear: string) => {
        return inputYear === currentYear;
    };

    const isError = isTouched && !isValidYear(year) || !!props.validity;

    return (
        <FormControlEvo>
            <FormLabelEvo mandatory={true}>{"Anti-spam: Doplňte aktuální rok"}</FormLabelEvo>
            <Input
                placeholder={"Doplňte aktuální rok"}
                defaultValue={props.defaultVal}
                type={"text"}
                name={fieldNameAndLabels.antiSpam.name}
                isInvalid={isError}
                onKeyDown={handleKeyPress}
                onInput={handleChangeYear}
            />
            {isError ? (
                <FormHelperText color={"red"}>{"Zadaný rok je nesprávný. Prosím zkuste to znovu."}</FormHelperText>
            ) : (
                <></>
            )}
        </FormControlEvo>
    );
};
